var configs = {
    breadcrumbs: {
        separator: '/',
        removeFirst: false
    }
};
export default configs;



//////////////////
// WEBPACK FOOTER
// ./node_modules/mmenu-js/dist/addons/navbars/_configs.js
// module id = 468
// module chunks = 0